import React from 'react';
export function EUFlagIcon({ size = 22, blue = '#0052CC', gold = '#FFD700', glow = true }) {
  return (
    <svg
      width={size}
      height={size * 0.67}
      viewBox="0 0 810 540"
      style={{
        display: 'inline-block',
        verticalAlign: 'middle',
        filter: glow ? 'drop-shadow(0 0 2px rgba(255,255,255,0.6))' : 'none',
      }}
    >
      <rect width="810" height="540" fill={blue} rx="40" />
      <g fill={gold}>
        {[...Array(12)].map((_, i) => {
          const angle = (i * 30 - 90) * (Math.PI / 180);
          const cx = 405 + 170 * Math.cos(angle);
          const cy = 270 + 170 * Math.sin(angle);
          return <circle key={i} cx={cx} cy={cy} r="22" />;
        })}
      </g>
    </svg>
  );
}